import { useCallback } from 'react';
import { Button, Theme, Tooltip, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { important } from 'common-types';
import { openCreateOrgModal } from '../../organizations/api/organizations-api';
import { setRemoveDemoOrg } from '../../organizations/store-actions/create-org-store-actions';

const DemoScanButton = () => {
  const { classes } = useStyles();

  const handleCreateDemoOrg = useCallback(() => {
    setRemoveDemoOrg(true);
    openCreateOrgModal();
  }, []);

  return (
    <Tooltip arrow placement='bottom' title={'Connect real data'}>
      <span>
        <Button
          sx={{ textTransform: 'none', cursor: 'pointer' }}
          color='primary'
          classes={{ disabled: classes.disabledScan }}
          variant={'contained'}
          onClick={handleCreateDemoOrg}>
          <Typography variant='caption' sx={{ whiteSpace: 'nowrap' }}>
            Connect Real Data Now
          </Typography>
        </Button>
      </span>
    </Tooltip>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  disabledScan: {
    color: important('rgba(255, 255, 255, 0.3)'),
    backgroundColor: important('rgba(255, 255, 255, 0.12)'),
    border: important('none'),
  },
}));

export default DemoScanButton;
